export const ensureResponses = (inputResponse) => {
  return inputResponse.map(response => {
    if (response['type'] === 'menu') {
      const items = response['payload']?.['items'].filter(item => {
        return item?.['action']?.['text']?.trim() !== '' && item?.['label']?.trim() !== ''
      });
      return {
        ...response, payload: { ...response['payload'], items  }
      }
    }
    if (response['type'] === 'card') {
      const cards = response['payload']?.['cards'].filter(card => {
        return (
          card?.['title'].trim() !== ''
          && card?.['content'].trim() !== ''
          && card?.['text'].trim() !== ''
          && card?.['link'].trim() !== ''
          && card?.['image'].trim() !== ''
        )
      });
      return {
        ...response, payload: { ...response['payload'], cards  }
      }
    }
    return response
  }).filter(response => {
    if (response['type'] === 'text') {
      return response['payload']?.['text']?.trim() !== '';
    }
    if (response['type'] === 'image') {
      return response['payload']?.['url']?.trim() !== '';
    }
    if (response['type'] === 'menu') {
      return response['payload']?.['title']?.trim() !== '' && response['payload']?.['items']?.length > 0;
    }
    if (response['type'] === 'menu') {
      return response['payload']?.['cards']?.length > 0;
    }
    // 其他類型保留
    return true;
  });
}